import { getLocationsBySlug, LocationItem } from '@api/locations';
import QueryKeys from '@lib/constants/QueryKeys';
import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

export default function useGetLocationsBySlug(slugs: string[]) {
  return useQuery<Array<LocationItem>, AxiosError>(QueryKeys.locationsBySlug(slugs), () => getLocationsBySlug(slugs), {});
}
